/* =============================================================================
   Curaprox — fix the Yotpo star-rating "scroll to reviews" landing.
   -----------------------------------------------------------------------------
   The PDP header star-rating widget (Yotpo instance 1355330, configured
   "Click to: Reviews summary") scrolls the reviews widget to the very top of the
   viewport (y = 0). The site's 48px sticky header then sits over that area, so the
   "Customer Reviews" heading ends up hidden behind the header — it looks like the
   click "scrolls down too much".

   Yotpo performs this scroll in JS (not via scrollIntoView / anchor), so CSS
   `scroll-margin-top` / `scroll-padding-top` are ignored. Instead we let Yotpo's
   own scroll settle, then nudge the page so the heading sits just below the header
   with a little breathing room.
   ============================================================================= */
(function () {
  var HEADER_OFFSET = 72; // 48px sticky header + ~24px breathing room

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.pdp-header__rating');
    if (!trigger) return;

    // Metafield-driven rating (<a href="#curaprox-reviews">): perform exactly ONE
    // smooth scroll to the "Customer reviews" heading and stop there. preventDefault
    // suppresses the browser's native anchor jump so the two never both fire, and
    // scrollIntoView honours the #curaprox-reviews `scroll-margin-top` (72px) so the
    // heading lands just below the sticky header — never deep at the Yotpo widget.
    if (trigger.tagName === 'A') {
      var reviews = document.getElementById('curaprox-reviews');
      if (reviews) {
        e.preventDefault();
        reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#curaprox-reviews');
      }
      return;
    }

    var widget = document.getElementById('yotpo-reviews-main-widget');
    if (!widget) return;

    // Wait for Yotpo's own scroll to bring the widget near the top AND settle,
    // then correct. setTimeout (not rAF) so it also runs in background tabs.
    var last = null;
    var tries = 0;
    (function settle() {
      var top = widget.getBoundingClientRect().top;
      var y = window.scrollY;
      var settled = last !== null && Math.abs(y - last) < 1;
      last = y;

      if (top < 60 && settled) {
        if (top < HEADER_OFFSET - 8) {
          window.scrollBy({ top: top - HEADER_OFFSET, behavior: 'smooth' });
        }
        return;
      }
      if (tries++ < 80) setTimeout(settle, 50); // ~4s safety window
    })();
  });
})();

/* =============================================================================
   Curaprox — hydrate the metafield-driven review summary (curaprox-review-summary).
   -----------------------------------------------------------------------------
   The summary + star distribution are server-rendered from Yotpo product
   metafields; the per-star counts + bar widths come from the JSON snapshot in
   `data-distribution` ({"1":n,…,"5":n}) against `data-total`. The custom
   "Write a review" button re-triggers Yotpo's own (off-screen) button so it opens
   the native review-form modal.
   ============================================================================= */
(function () {
  function initSummaries() {
    var blocks = document.querySelectorAll('.cura-reviews');
    for (var b = 0; b < blocks.length; b++) {
      var el = blocks[b];
      if (el.dataset.curaInit) continue;
      el.dataset.curaInit = '1';

      var total = parseInt(el.getAttribute('data-total'), 10) || 0;
      var dist = {};
      try {
        dist = JSON.parse(el.getAttribute('data-distribution') || '{}') || {};
      } catch (err) {
        dist = {};
      }

      // Bar widths are proportional to the LARGER of `data-total` (the reviews_count
      // metafield) and the sum of the per-star distribution. In a clean dataset these
      // are equal; when they disagree (e.g. a product whose reviews_count lags the
      // distribution snapshot) using the distribution sum keeps every bar proportional
      // instead of overflowing past 100% and clipping to a full track. The count text
      // still shows the raw per-star `n`.
      var distSum = 0;
      for (var k in dist) {
        if (Object.prototype.hasOwnProperty.call(dist, k)) {
          distSum += parseInt(dist[k], 10) || 0;
        }
      }
      var denom = Math.max(total, distSum);

      var rows = el.querySelectorAll('.cura-dist__row');
      for (var r = 0; r < rows.length; r++) {
        var star = rows[r].getAttribute('data-star');
        var n = parseInt(dist[star], 10) || 0;
        var pct = denom > 0 ? (n / denom) * 100 : 0;
        var fill = rows[r].querySelector('.cura-dist__fill');
        var count = rows[r].querySelector('.cura-dist__count');
        if (fill) fill.style.width = pct + '%';
        if (count) count.textContent = n;
      }

      var cta = el.querySelector('[data-cura-write-review]');
      if (cta) {
        cta.addEventListener('click', function () {
          var btn = document.querySelector(
            '.curaprox-yotpo-reviews .yotpo-new-review-btn, .curaprox-yotpo-reviews #yotpo-main-widget-btn'
          );
          if (btn) return btn.click();
          // No Yotpo button means the consent-gated loader never ran — the review
          // form needs Yotpo, so surface the consent dialog instead of a dead click.
          if (window.Cookiebot && window.Cookiebot.renew) window.Cookiebot.renew();
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSummaries);
  } else {
    initSummaries();
  }
})();

/* =============================================================================
   Curaprox — consent placeholder for the review list.
   -----------------------------------------------------------------------------
   Written for the consent-gated Yotpo loader (PR #54): while statistics consent
   was missing, the review-card area below the metafield summary stayed blank, and
   this block unhid the server-rendered placeholder ([data-cura-consent-placeholder],
   curaprox-review-summary.liquid) in its place.

   Since 063cdce the loader runs UNCONDITIONALLY (product decision, see
   theme.liquid) — the widget hydrates for decliners too, so a consent-keyed
   placeholder would sit on top of a working review list. The placeholder is
   therefore additionally keyed on the widget being ABSENT: it only appears when
   consent is missing AND nothing Yotpo has rendered (loader blocked again via
   Cookiebot config, an ad-blocker, or a future re-gating — in which case this
   block resumes its original job with no code change). A MutationObserver on the
   widget mount re-runs the check when Yotpo hydrates late, hiding the placeholder
   the moment review content lands. The CTA opens Cookiebot's renew dialog. With
   Cookiebot absent (previews without the app embed) the placeholder stays hidden.
   ============================================================================= */
(function () {
  function statisticsConsent() {
    return !!(window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.statistics);
  }

  function widgetRendered() {
    return !!document.querySelector(
      '.curaprox-yotpo-reviews .yotpo-main-reviews-widget, .curaprox-yotpo-reviews .yotpo-review, .curaprox-yotpo-reviews .yotpo-empty-state'
    );
  }

  function sync() {
    if (!window.Cookiebot) return;
    var placeholders = document.querySelectorAll('[data-cura-consent-placeholder]');
    for (var i = 0; i < placeholders.length; i++) {
      placeholders[i].hidden = statisticsConsent() || widgetRendered();
    }
  }

  // ConsentReady fires once Cookiebot knows the visitor's state (also for
  // returning visitors with a stored decision); Accept/Decline cover the live
  // banner interaction. The DOMContentLoaded sync handles the case where
  // Cookiebot initialised before this script ran.
  window.addEventListener('CookiebotOnConsentReady', sync);
  window.addEventListener('CookiebotOnAccept', sync);
  window.addEventListener('CookiebotOnDecline', sync);

  function start() {
    sync();
    // Yotpo hydrates the widget mount asynchronously (and possibly seconds after
    // load on slow connections) — watch it so a placeholder shown first is
    // withdrawn as soon as actual review content renders.
    var mount = document.querySelector('.curaprox-yotpo-reviews .yotpo-widget-instance');
    if (mount && window.MutationObserver) {
      new MutationObserver(sync).observe(mount, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cura-cookie-settings]');
    if (btn && window.Cookiebot && window.Cookiebot.renew) window.Cookiebot.renew();
  });
})();

/* =============================================================================
   §star-row — PDP header rating: Yotpo star widget vs the cookieless default.
   -----------------------------------------------------------------------------
   `product-details-header.liquid` emits TWO rows when the `yotpo.*` metafields
   carry no usable count, and exactly one may be visible:

     [data-cura-star-row]    the live Yotpo star-ratings widget (per store via
                             yotpo-ids.liquid — CH 1355330 / AE 1362951)
     [data-cura-star-empty]  the cookieless "No reviews yet" row

   The widget wins ONLY when it has hydrated AND reports a non-zero count. That
   covers the case the metafields cannot: Yotpo already has reviews the metafield
   sync has not pushed yet. In every other case — no statistics consent, no Yotpo
   account for this store, an ad-blocker, or a genuine zero — the cookieless row
   stays, which also avoids swapping a branded "No reviews yet" for Yotpo's own
   bare "0 Reviews".

   The count is read as the first integer in the widget's text ("0 Reviews",
   "3 Reviews"), which holds across widget languages since the number leads.
   Yotpo hydrates asynchronously and re-renders, so a MutationObserver re-runs it.
   Both rows carry `.pdp-header__rating` (display:flex), which beats the UA
   `[hidden]` rule — the matching `.pdp-header__rating[hidden]{display:none}`
   lives in product-details-header.liquid.
   ============================================================================= */
(function () {
  var row = document.querySelector('[data-cura-star-row]');
  if (!row) return;
  var fallback = document.querySelector('[data-cura-star-empty]');

  function reviewCount() {
    var widget = row.querySelector('.yotpo-reviews-star-ratings-widget');
    if (!widget) return 0;
    var match = (widget.textContent || '').match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  }

  function sync() {
    var showWidget = reviewCount() > 0;
    row.hidden = !showWidget;
    if (fallback) fallback.hidden = showWidget;
  }

  function start() {
    sync();
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(row, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* =============================================================================
   Curaprox — reveal the reviews-section START on numbered page change.
   -----------------------------------------------------------------------------
   On numbered ("horizontal") pagination, Yotpo scrolls to the top of the review list
   itself: its `scrollToTop()` calls `.yotpo-main-layout.scrollIntoView({block:'start'})`
   (verified against the live widget). `.yotpo-main-layout` sits ~328px BELOW our custom
   summary/heading, so the user lands on the list with the "Customer reviews" heading
   scrolled off the top.

   We can't beat that scroll from JS — Yotpo's pagination button calls stopPropagation,
   so a document-level click listener never fires, and Yotpo's scroll can land as late as
   several seconds after the click (after it re-renders the page). Instead we let Yotpo's
   OWN scroll do the work and just offset where it lands: because it uses `block:'start'`,
   it honours `scroll-margin-top` on `.yotpo-main-layout`. That CSS lives in
   assets/curaprox-yotpo-reviews.css (§18) and needs no JS.
   ============================================================================= */
